<template>
  <main class="standalone-preview">
    <div class="preview-topline">
      <div>
        <v-icon small color="primary">mdi-flask-outline</v-icon
        ><strong>Permission design preview</strong
        ><span>Sample groups and roles · changes stay on this browser</span>
      </div>
      <v-btn text small color="primary" to="/role"
        ><v-icon left small>mdi-arrow-left</v-icon>Back to Roles</v-btn
      >
    </div>
    <role static-preview />
  </main>
</template>
<script>
import Role from "./Role.vue";
export default { components: { Role } };
</script>
<style scoped>
.standalone-preview {
  min-height: 100vh;
  background: #f5f7fb;
}
.preview-topline {
  padding: 13px 28px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  border-bottom: 1px solid #dfe7f1;
  background: #fff;
}
.preview-topline > div {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
}
.preview-topline strong {
  font-size: 12px;
  color: #405a76;
}
.preview-topline span {
  font-size: 11px;
  color: #8595a8;
}
.preview-topline .v-btn {
  text-transform: none;
  letter-spacing: 0;
}
@media (max-width: 550px) {
  .preview-topline {
    padding: 12px 14px;
    align-items: flex-start;
  }
  .preview-topline span {
    width: 100%;
  }
}
</style>
